import { find, get } from "lodash";
import moment from "moment";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as newArticleAction from "~/actions/newArticle";
import Modal from "~/components/common/molecules/Modal";
import { SEO } from "~/components/common/molecules/SEO";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import MenuBarBottom from "~/components/mobile/molecules/MenuBar";
import { partnerInfo } from "~/configs/partnerDetails";
import { requestAllFeatures } from "~/store/features/featuresActions";
import { clearDataSearchFeeCode } from "~/store/fee/feeActions";
import { resetFollowUpExam } from "~/store/followUpExam/actions";
import { requestHospitalList } from "~/store/hospital/hospitalActions";
import * as notificationAction from "~/store/notifications/notificationsActions";
import { resetData, setPartnerId } from "~/store/totalData/actions";
import { NOTI } from "~/utils/constants";
import AppId from "~/utils/partner";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ClinicPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/Clinic"),
  loading: LoadableLoading,
  delay: 500
});

class ClinicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      triggerModal: false
    };
    this.scrollTop = 0;
    this.props.getFeaturedArticle();
    this.menuBarBottomRef = React.createRef();
    if (this.props.IsAuthenticated) {
      this.props.getNotificationOnPage({
        category: 1
      });
    }
  }

  handleShowNotiModal = () => {
    const today = moment().format("YYYY/MM/DD");
    const triggerModal = moment(today).isSameOrBefore("2021-02-18");
    const wasTriggered = sessionStorage.getItem("isTriggerModal");
    if (!wasTriggered) {
      if (triggerModal) {
        this.setState({ triggerModal: true });
        sessionStorage.setItem("isTriggerModal", true);
      }
    }
  };

  handleHideNotiModal = () => {
    this.setState({ triggerModal: !this.state.triggerModal });
  };

  componentDidMount() {
    if (AppId === "dkanphuoc") {
      this.handleShowNotiModal();
    }
    this.props.resetData();
    this.props.resetFollowUpExam();
    this.props.clearDataSearchFeeCode();
    this.props.setPartnerId(AppId);
    this.props.requestAllFeatures();
    this.props.requestHospitalList();
  }

  render() {
    if (AppId === "momo") {
      return <Redirect to="/chon-benh-vien" />;
    }

    return (
      <React.Fragment>
        <SEO
          title={`HTQL Phòng Khám/Phòng Mạch | ${hospitalName.value} `}
          meta={[
            {
              name: `description`,
              content: `Medpro, đặt khám trực tuyến, thanh toán viện phí, nhắc uống thuốc, khám chuyên khoa, bác sĩ, tư vấn sức khoẻ từ xa`
            },
            {
              property: `og:title`,
              content: "Trang chủ"
            },
            {
              property: `og:description`,
              content: `Medpro, đặt khám trực tuyến, thanh toán viện phí, nhắc uống thuốc, khám chuyên khoa, bác sĩ, tư vấn sức khoẻ từ xa`
            },
            {
              property: `og:url`,
              content: "https://testing.medpro.com.vn/"
            },
            {
              property: `og:image`,
              content:
                "https://cms.medpro.com.vn/uploads/small_medpro_f29ac22516.jpeg"
            },
            {
              property: `og:type`,
              content: `website`
            }
          ]}
        />

        <ClinicPageDesktop
          {...this.props}
          menuBarBottomRef={this.menuBarBottomRef}
        />

        <MenuBarBottom
          menuBarBottomRef={this.props.menuBarBottomRef}
          currentLocation={this.props.location.pathname}
        />
        <Modal
          iconTitle={<i className="fal fa-bell" />}
          modal={this.state.triggerModal}
          toggle={() => this.handleHideNotiModal()}
          title="Thông báo"
          children={NOTI}
          centered
          className="centered"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user,
    notification,
    newArticle
  } = state;
  return {
    device: type,
    IsAuthenticated: user.IsAuthenticated,
    userInfo: user.info,
    notification,
    newArticle
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getNotificationOnPage: data =>
      dispatch(notificationAction.getNotificationOnPage(data)),
    getNotification: data => dispatch(notificationAction.getNotification(data)),
    getFeaturedArticle: () => dispatch(newArticleAction.getFeaturedArticle()),
    requestAllFeatures: () => dispatch(requestAllFeatures()),
    resetData: () => dispatch(resetData()),
    resetFollowUpExam: () => dispatch(resetFollowUpExam()),
    clearDataSearchFeeCode: () => dispatch(clearDataSearchFeeCode()),
    setPartnerId: id => dispatch(setPartnerId(id)),
    requestHospitalList: () => dispatch(requestHospitalList())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClinicPage);
